import(/* webpackMode: "eager", webpackExports: ["PageAbout"] */ "/home/runner/work/Mitobyte/Mitobyte/src/app/about/__page__/PageAbout.tsx");
